"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.required = void 0;
const mobx_1 = require("mobx");
/** A rule that validates `value` is not `undefined`, `null`, or empty string. */
// We pre-emptively make this a mobx action so that it's identity doesn't change when proxied
// and breaks our ability to do `rules.some(r => r === required)`.
exports.required = (0, mobx_1.action)(({ value: v }) => {
    const isEmptyString = typeof v === "string" ? v.trim() === "" : false;
    return v !== undefined && v !== null && !isEmptyString ? undefined : "Required";
});
